import { useNavigate, useLocation, useSearchParams } from "react-router-dom"
import { useCallback } from "react"

interface BackNavigationConfig {
	fallbackRoute?: string
	onBack?: () => void
}

export const useComplexBackNavigation = (config?: BackNavigationConfig) => {
	const navigate = useNavigate()
	const location = useLocation()
	const [searchParams] = useSearchParams()

	const handleBackNavigation = useCallback(() => {
		const currentPath = location.pathname
		const currentStep = searchParams.get("step")
		if (currentPath === "/register") {
			const agencyDataParam = searchParams.get("agencyData")
			if (agencyDataParam === "true") {
				navigate("/register?agencyData=false", { replace: true })
				return
			}
			navigate("/login")
			return
		}

		if (currentPath === "/register-agency") {
			const stepNumber = currentStep ? Number.parseInt(currentStep, 10) : 1

			if (stepNumber > 1) {
				const prevStep = stepNumber - 1
				navigate(`/register-agency?step=${prevStep}`, { replace: true })
				return
			}
			navigate("/login")
			return
		}

		if (currentPath === "/register/stepper") {
			const stepNumber = currentStep ? Number.parseInt(currentStep, 10) : 1

			if (stepNumber > 1) {
				const prevStep = stepNumber - 1
				navigate(`/register/stepper?step=${prevStep}`, { replace: true })
				return
			}
			navigate("/register?agencyData=true", { replace: true })
			return
		}

		if (currentPath.startsWith("/register-agency/")) {
			if (currentPath === "/register-agency/verify") {
				navigate("/register-agency?step=1")
				return
			}

			if (currentPath === "/register-agency/welcome") {
				navigate("/register-agency?step=4")
				return
			}

			const flowPages = [
				"/register-agency/email-sent",
				"/register-agency/email-resend"
			]

			if (flowPages.includes(currentPath)) {
				navigate("/register-agency")
				return
			}
		}

		if (config?.onBack) {
			config.onBack()
			return
		}

		if (config?.fallbackRoute) {
			navigate(config.fallbackRoute)
			return
		}

		if (window.history.length > 1) {
			navigate(-1)
		} else {
			navigate("/login")
		}
	}, [location.pathname, searchParams, navigate, config])

	return { handleBackNavigation }
}
